import API, { DATA_API } from 'helpers/api'
import { Grade } from './grade'

export async function getStaffListAverageHoldTime({
  accountIds,
  filters,
  signal,
}: getStaffListAverageHoldTimeInput) {
  if (!accountIds.length) {
    return { summary: {}, records: [] } as never as Response
  }

  const data = {
    accountIds,
    filters,
  }

  const source = API.getCancelToken().source()

  const promise = API.get<Response>({
    api: DATA_API,
    url: '/calls/metrics/staff-average-hold-time',
    params: data,
    cancelToken: source.token,
  })

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  return promise
}

type getStaffListAverageHoldTimeInput = {
  accountIds: string[]
  filters: {}
  signal?: AbortSignal
}

export type Response = {
  summary: {
    total: number
    seconds: number
    averageSeconds: number
    grade: Grade
  }
  records: Array<{
    callHandlerId: string
    callHandlerName: string
    total: number
    seconds: number
    averageSeconds: number
    grade: Grade
  }>
}
